import l10n from '../l10n/localization';

export default {
    port: {
        presence: {
            message: l10n.validation.required,
        }
    }
};



// WEBPACK FOOTER //
// ./src/validation/cargoPort.js